import {
  Baby,
  BacteriaAttention,
  BacteriaAttentionAction,
  BacteriaAttentionCategory,
} from '@snapi/types';
import { useReportContext } from '../../report-context';
import {
  Description,
  DevInfo,
  Percentage,
  Subtitle,
  TextButton,
} from '@snapi/luxury';
import { bacteriaName } from '@snapi/ui-utils';
import clsx from 'clsx';

export const ReportRelatedCard: React.FC<
  BacteriaAttention & { onSelect: (name: string) => void }
> = ({
  name,
  taxonomy,
  percentage,
  action,
  threshold,
  comparator,
  category,
  categoryType,
  condition,
  onSelect,
}) => {
  const { baby } = useReportContext();

  return (
    <div
      className="relative flex flex-1 flex-col flex-shrink-0 bg-blue-light rounded-[10px] min-w-[280px] max-w-[380px] min-h-[180px] sm:min-h-[222px] px-3 py-4 cursor-pointer sm:w-[380px]"
      onClick={() => onSelect(name)}
    >
      <DevInfo>
        <span className="absolute top-2 right-2 font-mono">
          {comparator} {threshold}
        </span>
      </DevInfo>
      <div className="flex flex-col gap-3 sm:gap-2">
        {category === 'disruptive' || categoryType === 'disruptive' ? (
          <small className="flex flex-shrink-0 self-start px-4 py-1 rounded-full bg-red text-white uppercase">
            Disruptive
          </small>
        ) : (
          <small className="flex flex-shrink-0 self-start px-4 py-1 rounded-full bg-green text-body uppercase">
            Protective
          </small>
        )}
        <h4 className="flex flex-1">{bacteriaName(name, taxonomy)}</h4>
      </div>
      <div className="my-3 relative">
        <div className="absolute border-b border-body opacity-30 top-0 bottom-0 -left-3 -right-3"></div>
      </div>
      <div className="flex gap-2">
        <div
          className={clsx(
            'flex flex-col basis-1/2 p-2  rounded-[10px] h-[56px] sm:h-[80px] justify-between sm:p-3',
            category === 'key' &&
              Math.round(percentage * 10) / 10 < threshold * 0.75
              ? 'bg-pink-light border-[1px] border-red'
              : 'bg-white',
            category === 'disruptive' ||
              (categoryType === 'disruptive' &&
                Math.round(percentage * 10) / 10 > threshold * 0.75)
              ? 'bg-pink-light border-[1px] border-red'
              : 'bg-white',
            category === 'condition' &&
              categoryType === 'ptotective' &&
              Math.round(percentage * 10) / 10 < threshold * 0.75
              ? 'bg-pink-light border-[1px] border-red'
              : 'bg-white'
          )}
        >
          <div className="border-b-[0.5px] border-body text-[9px] sm:text-[12px] leading-[13px] sm:leading-[17px] sm:pb-1">
            <Subtitle>Your result now</Subtitle>
          </div>

          <Percentage
            className="text-[20px] sm:text-[26px] font-semibold mt-1 sm:mt-3"
            percentage={percentage}
          />
        </div>
        <div className="flex flex-col basis-1/2 p-2 bg-white rounded-[10px] h-[56px] sm:h-[80px] justify-between sm:p-3">
          <div className="border-b-[0.5px] border-body text-[9px] sm:text-[12px] leading-[13px] sm:leading-[17px] sm:pb-1">
            <Subtitle>Your goal</Subtitle>
          </div>

          <h5 className="mt-1 sm:mt-3">
            {category === 'disruptive' || categoryType === 'disruptive'
              ? 'under'
              : 'over'}
            <Percentage
              className="text-[20px] sm:text-[26px] font-semibold ml-2"
              percentage={threshold * 0.75}
            />
          </h5>
        </div>
      </div>

      <div className="flex mt-3">
        <TextButton onClick={() => onSelect(name)}>Learn more</TextButton>
      </div>
    </div>
  );
};
